import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSearchParamsLocalStorage, setSearchParamsLocalStorage } from 'lib/storage'

import { updateFiltersAction } from './actions'
import { getFilters } from './selectors'

const FiltersContext = React.createContext()

// eslint-disable-next-line react/prop-types
const FiltersProvider = ({ children }) => {
  const initialFilters = useSelector(getFilters)
  const dispatch = useDispatch()

  const [filters, setFilters] = useState(initialFilters)

  useEffect(() => {
    setFilters(initialFilters)
  }, [initialFilters])

  useEffect(() => {
    dispatch(updateFiltersAction(filters))

    const currentLocalSearch = getSearchParamsLocalStorage()
    const { stars, family, orderBy, facilities, accommodationTypes, ratings, maxPrice, minPrice } =
      filters
    setSearchParamsLocalStorage({
      ...currentLocalSearch,
      filters: {
        stars,
        family,
        orderBy,
        facilities,
        accommodationTypes,
        ratings,
        maxPrice,
        minPrice,
      },
    })
  }, [filters, dispatch])

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <FiltersContext.Provider value={{ filters, setFilters }}>{children}</FiltersContext.Provider>
  )
}

export { FiltersContext, FiltersProvider }
